module.exports = __webpack_public_path__ + "fonts/b00849e.woff";